// Reuse each PDP's purchase action; TrueFlame is the first enabled brand.
(() => {
  document.body.dataset.mobilePurchaseEnabled = 'true';
  const bound = new WeakSet();
  let previewObserved;
  const previewOffset = () => {
    const wrapper = document.getElementById('PBarNextFrameWrapper');
    if (!wrapper || wrapper === previewObserved) return;
    previewObserved = wrapper;
    const measure = () => document.body.style.setProperty('--purchase-preview-offset', wrapper.getBoundingClientRect().height + 'px');
    new ResizeObserver(measure).observe(wrapper);
    measure();
  };
  new MutationObserver(previewOffset).observe(document.body, { childList: true });
  previewOffset();
  const mount = () => {
    const accessory = document.querySelector('#napoleon-shopify-root');
    const accessoryName = accessory?.querySelector('.mobile-buy-bar small');
    const accessoryTitle = accessory?.querySelector('h1')?.textContent;
    if (accessoryName && accessoryTitle && accessoryName.textContent !== accessoryTitle) accessoryName.textContent = accessoryTitle;
    const root = document.querySelector('.fm-page:is([data-brand="TrueFlame"],[data-brand="Primo Ceramic Grills"])');
    if (!root || bound.has(root)) return;
    const bar = root.querySelector('.fm-mobile-buy');
    const primary = root.querySelector('#fire-magic-product-form [type="submit"]');
    const button = bar?.querySelector('button');
    if (!bar || !primary || !button) return;
    bound.add(root);
    // Forward to the existing action, including required carts and selected extras.
    button.type = 'button';
    button.removeAttribute('form');
    button.addEventListener('click', () => primary.click());
    const sync = () => {
      if (!root.isConnected) { observer.disconnect(); return; }
      const name = bar.querySelector('[data-fm-mobile-name]');
      name.textContent = root.querySelector('h1').textContent;
      button.textContent = primary.textContent;
      button.disabled = primary.disabled;
      button.setAttribute('aria-busy', String(primary.textContent.includes('Adding')));
      button.setAttribute('aria-live', 'polite');
    };
    const observer = new MutationObserver(sync);
    observer.observe(primary, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    observer.observe(root.querySelector('h1'), { childList: true, subtree: true, characterData: true });
    sync();
  };
  new MutationObserver(mount).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  mount();
})();
